import moment from 'moment';

import Agreement from '../models/Agreement';

const agreementFilter = (agreement: Agreement, searchFields: any[]) => {
  const agreementSearch = searchFields.filter(field => field.fieldName === 'Agreement Date');
  const companySearch = searchFields.find(field => field.fieldName === 'Company Name');
  const statusSearch = searchFields.find(field => field.fieldName === 'Status');
  const fileNoSearch = searchFields.filter(field => field.fieldName === 'File No');
  const notesSearch = searchFields.filter(field => field.fieldName === 'Notes');
  const initialAgreementSearch = searchFields.filter(
    field => field.fieldName === 'Initial Agreement'
  );

  if (
    companySearch &&
    Array.isArray(companySearch.value) &&
    !companySearch.value.some((x: string) => x === agreement.companyName)
  ) {
    return false;
  }

  if (
    statusSearch &&
    Array.isArray(statusSearch.value) &&
    !statusSearch.value.some((x: string) => x === agreement.status)
  ) {
    return false;
  }

  if (
    notesSearch &&
    Array.isArray(notesSearch) &&
    notesSearch[0] &&
    !agreement.notes.toLowerCase().includes(notesSearch[0].value.toLowerCase())
  ) {
    return false;
  }

  if (
    initialAgreementSearch &&
    Array.isArray(initialAgreementSearch) &&
    initialAgreementSearch[0] &&
    !agreement.initialAgreementCovers
      .toLowerCase()
      .includes(initialAgreementSearch[0].value.toLowerCase())
  ) {
    return false;
  }

  if (
    agreementSearch &&
    agreementSearch.length &&
    !moment(agreement.agreementDate, 'L').isValid()
  ) {
    return false;
  }

  if (
    agreementSearch &&
    agreementSearch.length === 1 &&
    agreementSearch[0].operator === '=' &&
    moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[0].value, 'L')) !== 0
  ) {
    return false;
  }

  if (
    agreementSearch &&
    agreementSearch.length === 1 &&
    agreementSearch[0].operator === '≥' &&
    moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[0].value, 'L')) < 0
  ) {
    return false;
  }

  if (
    agreementSearch &&
    agreementSearch.length === 1 &&
    agreementSearch[0].operator === '≤' &&
    moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[0].value, 'L')) > 0
  ) {
    return false;
  }

  if (
    agreementSearch &&
    agreementSearch.length === 2 &&
    agreementSearch[0].operator === '≥' &&
    moment(agreementSearch[0].value, 'L').diff(moment(agreementSearch[1].value, 'L')) > 0 &&
    moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[0].value, 'L')) < 0 &&
    moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[1].value, 'L')) > 0
  ) {
    return false;
  }

  if (
    agreementSearch &&
    agreementSearch.length === 2 &&
    agreementSearch[0].operator === '≤' &&
    moment(agreementSearch[0].value, 'L').diff(moment(agreementSearch[1].value, 'L')) < 0 &&
    moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[0].value, 'L')) > 0 &&
    moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[1].value, 'L')) < 0
  ) {
    return false;
  }

  if (
    agreementSearch &&
    agreementSearch.length === 2 &&
    agreementSearch[0].operator === '≤' &&
    moment(agreementSearch[0].value, 'L').diff(moment(agreementSearch[1].value, 'L')) > 0 &&
    (moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[0].value, 'L')) > 0 ||
      moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[1].value, 'L')) < 0)
  ) {
    return false;
  }

  if (
    agreementSearch &&
    agreementSearch.length === 2 &&
    agreementSearch[0].operator === '≥' &&
    moment(agreementSearch[0].value, 'L').diff(moment(agreementSearch[1].value, 'L')) < 0 &&
    (moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[0].value, 'L')) < 0 ||
      moment(agreement.agreementDate, 'L').diff(moment(agreementSearch[1].value, 'L')) > 0)
  ) {
    return false;
  }

  if (fileNoSearch && !agreement.fileNumber.length) {
    return false;
  }

  if (
    fileNoSearch &&
    fileNoSearch.length === 1 &&
    fileNoSearch[0].operator === '≥' &&
    agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[0].value.length) <
      fileNoSearch[0].value.toLowerCase()
  ) {
    return false;
  }

  if (
    fileNoSearch &&
    fileNoSearch.length === 1 &&
    fileNoSearch[0].operator === '≤' &&
    agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[0].value.length) >
      fileNoSearch[0].value.toLowerCase()
  ) {
    return false;
  }

  if (
    fileNoSearch &&
    fileNoSearch.length === 2 &&
    fileNoSearch[0].operator === '≥' &&
    fileNoSearch[0].value > fileNoSearch[1].value &&
    agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[0].value.length) <
      fileNoSearch[0].value.toLowerCase() &&
    agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[1].value.length) >
      fileNoSearch[1].value.toLowerCase()
  ) {
    return false;
  }

  if (
    fileNoSearch &&
    fileNoSearch.length === 2 &&
    fileNoSearch[0].operator === '≤' &&
    fileNoSearch[0].value < fileNoSearch[1].value &&
    agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[1].value.length) <
      fileNoSearch[1].value.toLowerCase() &&
    agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[0].value.length) >
      fileNoSearch[0].value.toLowerCase()
  ) {
    return false;
  }

  if (
    fileNoSearch &&
    fileNoSearch.length === 2 &&
    fileNoSearch[0].operator === '≤' &&
    fileNoSearch[0].value > fileNoSearch[1].value &&
    (agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[0].value.length) >
      fileNoSearch[0].value.toLowerCase() ||
      agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[1].value.length) <
        fileNoSearch[1].value.toLowerCase())
  ) {
    return false;
  }

  if (
    fileNoSearch &&
    fileNoSearch.length === 2 &&
    fileNoSearch[0].operator === '≥' &&
    fileNoSearch[0].value < fileNoSearch[1].value &&
    (agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[0].value.length) <
      fileNoSearch[0].value.toLowerCase() ||
      agreement.fileNumber.toLowerCase().slice(0, fileNoSearch[1].value.length) >
        fileNoSearch[1].value.toLowerCase())
  ) {
    return false;
  }

  if (
    fileNoSearch &&
    fileNoSearch.length &&
    !fileNoSearch.find(f => f.operator === '≥') &&
    !fileNoSearch.find(f => f.operator === '≤')
  ) {
    for (const filter of fileNoSearch) {
      if (
        filter.operator === '=' &&
        filter.value.toLowerCase() === agreement.fileNumber.toLowerCase()
      ) {
        return true;
      }

      if (
        filter.operator === '≈' &&
        agreement.fileNumber.toLowerCase().includes(filter.value.toLowerCase())
      ) {
        return true;
      }
    }

    return false;
  }

  return true;
};

export default agreementFilter;
